import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useSubmitButton } from './hooks/useSubmitButton';

export const SubmitButton: React.FC = () => {
	const {
		data: { hideSubmit },
	} = useSubmitButton();

	if (hideSubmit) {
		return null;
	}

	return (
		<Button
			variant="primary"
			size="small"
			type="submit"
			data-qa="report-abuse-submit-button"
			className="sm:w-full lg:w-[120px]"
		>
			<Translate value="corgi.policy_abuse.generic.form_submit" />
		</Button>
	);
};
